module.exports = __webpack_public_path__ + "static/media/404.52339693.png";